import { AnyAction } from "redux";
import { MODULE_NAME } from "../moduleName";
import { OfqualNotification } from "../services/domain/OfqualNotification";
import { PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

// a global action from portal-auth module
export const LOGIN_COMPLETE = "auth/LOGIN_COMPLETE";

export const TOGGLE_NOTIFICATION_PANEL = `${MODULE_NAME}/TOGGLE_NOTIFICATION_PANEL`;

export const UPDATE_PARAMS = `${MODULE_NAME}/UPDATE_PARAMS`;
export const LOADING_NOTIFICATIONS = `${MODULE_NAME}/LOADING_NOTIFICATIONS`;
export const LOADED_NOTIFICATIONS = `${MODULE_NAME}/LOADED_NOTIFICATIONS`;
export const READING_NOTIFICATION = `${MODULE_NAME}/READING_NOTIFICATION`;
export const READ_NOTIFICATION = `${MODULE_NAME}/READ_NOTIFICATION`;
export const TOGGLE_BULK_MODE = `${MODULE_NAME}/TOGGLE_BULK_MODE`;

export const TOGGLE_SHOULD_CLEAR_NOTIFICATION = `${MODULE_NAME}/TOGGLE_SHOULD_CLEAR_NOTIFICATION`;
export const CLEAR_ALL_SHOULD_CLEAR_NOTIFICATION = `${MODULE_NAME}/CLEAR_ALL_SHOULD_CLEAR_NOTIFICATION`;
export const READING_NOTIFICATION_BULK = `${MODULE_NAME}/READING_NOTIFICATION_BULK`;
export const READ_NOTIFICATION_BULK = `${MODULE_NAME}/READ_NOTIFICATION_BULK`;

export const PUSH_NOTIFICATION = `${MODULE_NAME}/PUSH_NOTIFICATION`;

export const updateParams = (newParams: QueryParams) => ({
  type: UPDATE_PARAMS,
  payload: newParams,
});

export const loadedNotifications = (
  payload: PagedResponse<OfqualNotification>
) => ({
  type: LOADED_NOTIFICATIONS,
  payload,
});

export const loadingNotifications = () => ({
  type: LOADING_NOTIFICATIONS,
});

export const readingNotification = (id: string) => ({
  type: READING_NOTIFICATION,
  payload: id,
});

export const readNotification = (id: string) => ({
  type: READ_NOTIFICATION,
  payload: id,
});

export const toggle = (isOpen: boolean) => ({
  type: TOGGLE_NOTIFICATION_PANEL,
  payload: isOpen,
});

export const toggleBulkMode = (isBulkMode: boolean) => ({
  type: TOGGLE_BULK_MODE,
  payload: isBulkMode,
});

export const toggleBulkModeClearNotification = (
  ids: string[],
  shouldClear: boolean
) => ({
  type: TOGGLE_SHOULD_CLEAR_NOTIFICATION,
  payload: {
    ids,
    shouldClear,
  },
});

export const removeAllShouldClearNotification = () => ({
  type: CLEAR_ALL_SHOULD_CLEAR_NOTIFICATION,
});

export const readNotificationBulk = () => ({
  type: READ_NOTIFICATION_BULK,
});

export const readingNotificationBulk = () => ({
  type: READING_NOTIFICATION_BULK,
});

export const pushNotification = (payload: OfqualNotification) => ({
  type: PUSH_NOTIFICATION,
  payload
});